import React from 'react';
import { Class as BemGen, } from 'classname-generator';
const bemGen = new BemGen({
  bemEnabled: true,
})

const blockElementsNames = ['label', 'link', 'close-button']
export const classNameBlock = bemGen({
  name: 'cookie-disclaimer',
  elements: [{
    name: 'message',
    elements: blockElementsNames.map(elementName => {
      return {
        name: elementName
      }
    })
  }, {
    name: 'message',
    alias: 'transitionedMessage',
    modifiers: {
      transition: true
    }
  }]
})
export function CookieDisclaimerComponent({ text, linkText, link, onClick }){
  return (
  <div key="cookie-disclaimer" className={ classNameBlock.message }>
    <label className={ classNameBlock.message.label }>
      { `${text} ` }
      <a className={ classNameBlock.message.link } href={ link }>
        { linkText }
      </a>
     </label>
    <div className={ classNameBlock.message.closeButton } onClick={ onClick }/>
  </div>
  )
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/cookieDisclaimer/cookieDisclaimerComponent.js